import { APP_BASE_HREF, registerLocaleData } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '@environments/environment';
import { AnimationsModule } from '@ibe.animations/animations.module';
import { TAPCommonModule } from '@ibe.components/common/common.module';
import { SharedModule } from '@ibe.components/shared/shared.module';
import { TAPNotFoundModule } from '@ibe.components/not-found/not-found.module';
import { IsDownModule } from '@ibe.components/is-down/is-down.module';
import { AppRoutingModule, SidebarRoutingModule } from '@ibe/routing';
import { UserIdleModule } from 'angular-user-idle';
// import { TripFinderModule } from '@ibe.components/trip-finder/trip-finder.module';
// import { RefundsModule } from '@ibe.components/refunds/refunds.module';
/* STORE */
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { NgxPageScrollCoreModule } from 'ngx-page-scroll-core';
import { AppComponent } from './app.component';
// import { TAPAppComponent } from './app.tap.component';
import { BookedTripEffect, BookingStepsEffect, BookingTotalSummaryEffect } from './effects/index';
import { metaReducers, reducers, effects } from './store';
import { MultipleModalModule } from '@ibe.components/common/modal/multiple-modal/multiple-modal.module';
import { ExamplesComponent } from './services/mocks.tap/examples/examples.component';
import { CustomSerializer } from './store/states/router.state';

import localePT from '@angular/common/locales/pt-PT';
import { CookieService } from 'ngx-cookie-service';

/* REPLICATED FILES */
import { INDRAAppComponent } from './app.indra.component';
import { ErrorHttpInterceptor } from './interceptor/http.indra.interceptor';
import { CookieInterceptor } from './interceptor/cookie.indra.interceptor';

registerLocaleData(localePT);

@NgModule({
	declarations: [AppComponent, INDRAAppComponent, ExamplesComponent],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		/**
     * StoreModule.provideStore is imported once in the root module, accepting a reducer
     * function or object map of reducer functions. If passed an object of
     * reducers, combineReducers will be run creating your application
     * meta-reducer. This returns all providers for an @ngrx/store
     * based application.
     */
		StoreModule.forRoot(reducers, ({ metaReducers })),
		/**
		* Store devtools instrument the store retaining past versions of state
		* and recalculating new states. This enables powerful time-travel
		* debugging.
		*
		* To use the debugger, install the Redux Devtools extension for either
		* Chrome or Firefox
		*
		* See: https://github.com/zalmoxisus/redux-devtools-extension
		*/
		StoreDevtoolsModule.instrument({
			maxAge: 20
		}),
		EffectsModule.forRoot(effects),
		// Connects RouterModule with StoreModule
		StoreRouterConnectingModule.forRoot({
			serializer: CustomSerializer
		}),
		HttpClientModule,
		FormsModule,
		ReactiveFormsModule,
		AnimationsModule,
		SharedModule,
		SidebarRoutingModule,
		AppRoutingModule,
		TAPNotFoundModule,
		IsDownModule,
		// TripFinderModule,
		// RefundsModule,
		TAPCommonModule,
		MultipleModalModule,
		UserIdleModule.forRoot({idle: 5, timeout: 1}),
		NgxPageScrollCoreModule.forRoot()
	],
	providers: [
			{ provide: APP_BASE_HREF, useValue: environment.base_href },
			{ provide: 'ga-indra', useValue: environment.ga_indra },
			{ provide: 'ga-tap', useValue: environment.ga_tap },
			BookedTripEffect,
			BookingStepsEffect,
			BookingTotalSummaryEffect,
			{ provide: HTTP_INTERCEPTORS, useClass: ErrorHttpInterceptor, multi: true },
			{ provide: HTTP_INTERCEPTORS, useClass: CookieInterceptor, multi: true },
			CookieService
		],
	bootstrap: [INDRAAppComponent]
})
export class AppModule { }
